import { application } from "./application"
import { registerControllers } from "stimulus-vite-helpers"
import { registerControllers as registerLayoutControllers } from "@asgerb/apparatus-layout"

const controllers = import.meta.globEager("./**/*_controller.js")
const componentControllers = import.meta.globEager(
  "../../components/**/*_controller.js"
)
registerControllers(application, controllers)
registerControllers(application, componentControllers)
registerLayoutControllers(application)
